import dayjs from "dayjs";

export default {
  data() {
    return {
      bs: {
        2000: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2001: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2002: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2003: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2004: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2005: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2006: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2007: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2008: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
        2009: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2010: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2011: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2012: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        2013: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2014: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2015: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2016: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        2017: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2018: [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2019: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2020: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2021: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2022: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        2023: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2024: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2025: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2026: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2027: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2028: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2029: [31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
        2030: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2031: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2032: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2033: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2034: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2035: [30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
        2036: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2037: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2038: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2039: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        2040: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2041: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2042: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2043: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        2044: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2045: [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2046: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2047: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2048: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2049: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        2050: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2051: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2052: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2053: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        2054: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2055: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2056: [31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
        2057: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2058: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2059: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2060: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2061: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2062: [30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
        2063: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2064: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2065: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2066: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
        2067: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2068: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2069: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2070: [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
        2071: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2072: [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
        2073: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
        2074: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2075: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2076: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        2077: [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
        2078: [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
        2079: [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
        2080: [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
        2081: [31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2082: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2083: [31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
        2084: [31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
        2085: [31, 32, 31, 32, 30, 31, 30, 30, 29, 30, 30, 30],
        2086: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2087: [31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
        2088: [30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
        2089: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
        2090: [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30]
      },
      // bsEquivalent: '2070-1-1',
      // adEquivalent: '2013-4-14',
      bsEquivalent: "2000-9-17",
      adEquivalent: "1944-1-1"
    };
  },
  created() {
    this.bs = {};
    this.bs[2000] = [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31];
    this.bs[2001] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2002] = [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2003] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2004] = [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31];
    this.bs[2005] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2006] = [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2007] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2008] = [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31];
    this.bs[2009] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2010] = [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2011] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2012] = [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30];
    this.bs[2013] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2014] = [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2015] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2016] = [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30];
    this.bs[2017] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2018] = [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2019] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31];
    this.bs[2020] = [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2021] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2022] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30];
    this.bs[2023] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31];
    this.bs[2024] = [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2025] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2026] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2027] = [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31];
    this.bs[2028] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2029] = [31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2030] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2031] = [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31];
    this.bs[2032] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2033] = [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2034] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2035] = [30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31];
    this.bs[2036] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2037] = [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2038] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2039] = [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30];
    this.bs[2040] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2041] = [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2042] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2043] = [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30];
    this.bs[2044] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2045] = [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2046] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2047] = [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2048] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2049] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30];
    this.bs[2050] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31];
    this.bs[2051] = [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2052] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2053] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30];
    this.bs[2054] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31];
    this.bs[2055] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2056] = [31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2057] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2058] = [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31];
    this.bs[2059] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2060] = [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2061] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2062] = [30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31];
    this.bs[2063] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2064] = [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2065] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2066] = [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31];
    this.bs[2067] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2068] = [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2069] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2070] = [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30];
    this.bs[2071] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2072] = [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30];
    this.bs[2073] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];
    this.bs[2074] = [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2075] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2076] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30];
    this.bs[2077] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31];
    this.bs[2078] = [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2079] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
    this.bs[2080] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30];
    this.bs[2081] = [31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30];
    this.bs[2082] = [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30];
    this.bs[2083] = [31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30];
    this.bs[2084] = [31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30];
    this.bs[2085] = [31, 32, 31, 32, 30, 31, 30, 30, 29, 30, 30, 30];
    this.bs[2086] = [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30];
    this.bs[2087] = [31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30];
    this.bs[2088] = [30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30];
    this.bs[2089] = [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30];
    this.bs[2090] = [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30];
  },
  methods: {
    dateDiffInDays(a, b) {
      // Discard the time and time-zone information.
      const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
      return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
    },
    countBsDays(beginBSDate, endBSDate) {
      // Returns the number of days between the two given B.S. dates.
      // begin_ad_date : A tuple in the format (year,month,day) that specify the date to start counting from.
      // end_ad_date : A tuple in the format (year,month,day) that specify the date to end counting.
      // NOTE:
      // Tuple in the dictionary starts from 0
      // The range(a,b) function starts from a and ends at b-1
      const [beginYear, beginMonth, beginDay] = beginBSDate
        .split("-")
        .map(data => parseInt(data));
      const [endYear, endMonth, endDay] = endBSDate
        .split("-")
        .map(data => parseInt(data));
      let days = 0;
      let beginYearDays = 0;
      let totalBeingYearDays = 0;
      // 1) First add total days in all the years
      for (let year = beginYear; year < endYear + 1; year++) {
        for (const daysInMonths of this.bs[year]) {
          days = days + daysInMonths;
        }
      }
      for (let month = 0; month < 12; month++) {
        totalBeingYearDays = totalBeingYearDays + this.bs[beginYear][month];
      }
      for (let month = beginMonth - 1; month < 12; month++) {
        beginYearDays = beginYearDays + this.bs[beginYear][month];
      }
      beginYearDays = totalBeingYearDays - beginYearDays + beginDay - 1;
      // // 2) Subtract the days from first (n-1) months of the beginning year
      // for (let month = 0; month < beginMonth; month++) {
      //   days = days - this.bs[beginYear][month]
      // }
      // // 3) Add the number of days from the last month of the beginning year
      // days = days + this.bs[beginYear][12 - 1]
      // 4) Subtract the days from the last months from the end year
      for (let month = endMonth - 1; month < 12; month++) {
        days = days - this.bs[endYear][month];
      }
      // 5) Add the beginning days excluding the day itself
      // days = days - beginDay - 1
      // 5) Add the last remaining days excluding the day itself
      days = days + endDay - 1;
      return days - beginYearDays;
    },
    countAdDays(beginADDate, endADDate) {
      // Returns the number of days between the two given A.D. dates.
      // begin_ad_date : A tuple in the format (year,month,day) that specify the date to start counting from.
      // end_ad_date : A tuple in the format (year,month,day) that specify the date to end counting.
      const dateBegin = new Date(beginADDate);
      const dateEnd = new Date(endADDate);
      return this.dateDiffInDays(dateBegin, dateEnd);
    },
    addAdDays(adDate, numOfDays) {
      // Adds the given number of days to the given A.D. date and returns it as a tuple in the format (year,month,day)
      // ad_date : A tuple in the format (year,month,day)
      // num_days : Number of days to add to the given date
      const date = new Date(adDate);
      date.setDate(date.getDate() + numOfDays);
      const monthPadding = date.getMonth() + 1 < 10 ? "0" : "";
      const datePadding = date.getDate() < 10 ? "0" : "";
      return `${date.getFullYear()}-${monthPadding}${date.getMonth() +
        1}-${datePadding}${date.getDate()}`;
    },
    addBsDays(bsDate, numOfDays) {
      // Adds the given number of days to the given B.S. date and returns it as a tuple in the format (year,month,day)
      // bsDate : a tuple in the format (year,month,day)
      // numOfDays : Number of days to add to the given date
      // Note:
      // Tuple in the dictionary starts from 0
      let [year, month, day] = bsDate.split("-").map(data => parseInt(data));
      // 1) Add the total number of days to the original days
      day = day + numOfDays;
      if (day < 1) {
        this.error = "No mapping provided for the selected year and month.";
        setTimeout(() => {
          this.error = "";
        }, 1500);
        return this.bsEquivalent;
      }
      // 2) Until the number of days becomes applicable to the current month,
      // subtract the days by the number of days in the current month and increase the month
      while (day > this.bs[year][month - 1]) {
        day = day - this.bs[year][month - 1];
        month = month + 1;
        if (month > 12) {
          month = 1;
          year = year + 1;
        }
      }
      const monthPadding = month < 10 ? "0" : "";
      const datePadding = day < 10 ? "0" : "";
      return `${year}-${monthPadding}${month}-${datePadding}${day}`;
    },
    bs2ad(bsDate) {
      if (this.is_valid(bsDate)) {
        // input and output in string
        const [year, month, day] = bsDate
          .split("-")
          .map(data => parseInt(data));
        if (day > this.bs[year][month - 1]) {
          this.day = this.bs[year][month - 1];
          bsDate = year + "-" + month + "-" + this.day;
        }
        const dateDelta = this.countBsDays(this.bsEquivalent, bsDate);
        return this.addAdDays(this.adEquivalent, dateDelta);
      } else {
        throw Error(`Invalid BS Date - ${bsDate}`);
      }
    },
    ad2bs(adDate) {
      // Returns the B.S. equivalent date as a tuple in the format (year,month,day) if the date is within range, else returns None
      // bsDate : A tuple in the format (year,month,day)
      if (!adDate) {
        return null;
      }
      const dt = new Date(adDate);
      if (dt instanceof Date && !isNaN(dt)) {
        const dateDelta = this.countAdDays(this.adEquivalent, adDate);
        return this.addBsDays(this.bsEquivalent, dateDelta);
      }
      throw Error(`Invalid Date - ${adDate}`);
    },
    getBSYear(adDate) {
      const bsDate = this.ad2bs(adDate);
      return parseInt(bsDate.split("-")[0]);
    },
    getBSMonth: function(adDate) {
      const bsDate = this.ad2bs(adDate);
      return parseInt(bsDate.split("-")[1]);
    },
    getBSDate: function(adDate) {
      const bsDate = this.ad2bs(adDate);
      return parseInt(bsDate.split("-")[2]);
    },
    is_valid(dateAsString) {
      // """
      // Checks if the fed date string is a valid B.S. date
      // date_as_str: String in the format 'YYYY-MM-DD'
      // Returns True for valid date, False for invalid.
      // """
      let [year, month, day] = [null, null, null];
      try {
        [year, month, day] = dateAsString
          .split("-")
          .map(data => parseInt(data));
      } catch (e) {
        return false;
      }
      if (!(month > 0 && month < 13)) {
        return false;
      }
      try {
        if (!(day > 0 && day <= this.bs[year][month - 1])) {
          return false;
        }
      } catch (e) {
        throw Error(`The year ${year} is not supported`);
      }
      return true;
    },
    getMonthDays(year, month) {
      try {
        return this.bs[year][month - 1];
      } catch (e) {
        throw Error(`BS ${year} not supported.`);
      }
    },
    getYears() {
      return Object.keys(this.bs);
    },
    getMonths() {
      return [
        "बैशाख",
        "जेठ",
        "असार",
        "साउन",
        "भदौ",
        "असोज",
        "कार्तिक",
        "मंसिर",
        "पुष",
        "माघ",
        "फागुन",
        "चैत"
      ];
    },
    getDays() {
      return [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
    },
    getThisYearStartDate() {
      const adDateToday = dayjs().format("YYYY-MM-DD");
      const bsDateToday = this.ad2bs(adDateToday);
      const newBsDate = bsDateToday.split("-")[0] + "-01-01";
      return this.bs2ad(newBsDate);
    },
    getThisYearEndDate() {
      const adDateToday = dayjs().format("YYYY-MM-DD");
      const bsDateToday = this.ad2bs(adDateToday);
      const newBsDate =
        bsDateToday.split("-")[0] +
        "-12-" +
        this.bs[bsDateToday.split("-")[0]][11];
      return this.bs2ad(newBsDate);
    },
    getLastYearStartDate() {
      const adDateToday = dayjs().format("YYYY-MM-DD");
      const bsDateToday = this.ad2bs(adDateToday);
      const newBsDate = bsDateToday.split("-")[0] - 1 + "-01-01";
      return this.bs2ad(newBsDate);
    },
    getLastYearEndDate() {
      const adDateToday = dayjs().format("YYYY-MM-DD");
      const bsDateToday = this.ad2bs(adDateToday);
      const newBsDate =
        bsDateToday.split("-")[0] -
        1 +
        "-12-" +
        this.bs[bsDateToday.split("-")[0] - 1][11];
      return this.bs2ad(newBsDate);
    },
    getMonthStartDate(adDate) {
      return this.getMonthDate("start", adDate);
    },
    getMonthEndDate(adDate) {
      return this.getMonthDate("end", adDate);
    },
    getMonthDate(key, adDate) {
      let adDateToday = dayjs().format("YYYY-MM-DD");
      if (adDate) {
        adDateToday = adDate;
      }
      const bsDateToday = this.ad2bs(adDateToday);
      let newBsDate = "";
      if (key === "start") {
        newBsDate =
          bsDateToday.split("-")[0] + "-" + bsDateToday.split("-")[1] + "-01";
      } else if (key === "end") {
        newBsDate =
          bsDateToday.split("-")[0] +
          "-" +
          bsDateToday.split("-")[1] +
          "-" +
          this.bs[bsDateToday.split("-")[0]][bsDateToday.split("-")[1] - 1];
      } else {
        throw Error("Key not valid for conversion.");
      }
      return this.bs2ad(newBsDate);
    },
    getLastMonthStartDate() {
      return this.getLastMonthDate("start");
    },
    getLastMonthEndDate() {
      return this.getLastMonthDate("end");
    },
    getLastMonthDate(key) {
      const adDateToday = dayjs().format("YYYY-MM-DD");
      const bsDateToday = this.ad2bs(adDateToday);
      const bsYear =
        bsDateToday.split("-")[1] - 1 > 0
          ? bsDateToday.split("-")[0]
          : bsDateToday.split("-")[0] - 1;
      const bsLastMonth =
        bsDateToday.split("-")[1] - 1 > 0 ? bsDateToday.split("-")[1] - 1 : 12;
      let newBsDate = "";
      if (key === "start") {
        newBsDate = bsYear + "-" + bsLastMonth + "-01";
      } else if (key === "end") {
        newBsDate =
          bsYear + "-" + bsLastMonth + "-" + this.bs[bsYear][bsLastMonth - 1];
      } else {
        throw Error("Key not valid for conversion.");
      }
      return this.bs2ad(newBsDate);
    }
  }
};
